import { connect } from 'react-redux';

import {
    ScreenErrorMessage,
    ScreenErrorMessageProps
} from '../../components/ScreenErrorMessage/ScreenErrorMessage';
import { State } from '../../typings/state';
import { TStateProps } from '../../typings/utils';

type StateProps = TStateProps<ScreenErrorMessageProps>;

interface OwnProps {
    cls?: string;
}

const mapStateToProps = ({ commonData }: State): StateProps => {
    const {
        screenError: { message, isVisible, showLinkSwitchOnOldInterface, title }
    } = commonData;

    return {
        header: title,
        text: message,
        isVisible,
        showLinkSwitchOnOldInterface
    };
};

export const GlobalScreenErrorMessageContainer = connect<
    StateProps,
    {},
    OwnProps
>(mapStateToProps)(ScreenErrorMessage);
